// extracted by mini-css-extract-plugin
export default {"resources":"Resources_resources__BMKQa"};